// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Laa-z","subtitle":"Maa-z","wrapper":"Naa-z","leftArrow":"Oaa-z","rightArrow":"Paa-z"};